import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_09e1f5ae from '../styles/Row.module.less.js';

const SubRow = (props) => {
    const { children, className, ...restProps } = props;
    const cx = useStyles(modules_09e1f5ae);
    return (React.createElement("tr", { className: cx(className, 'row', 'sub-row'), ...restProps }, children));
};

export { SubRow };
//# sourceMappingURL=SubRow.js.map
